let counter = 0;
const selector = "[bss-b2b-main-product-form]";
let blocked = false;

const interval = setInterval(() => {
  const element = document.querySelector(selector);
  const store = BSS_B2B?.storage?.variantStorage?.store;

  const block = document.querySelector("[bss-b2b-quantity-block]");

  if (block && !blocked) {
    block.style.pointerEvents = "none";
    block.style.opacity = "0.6";
    blocked = true;
  }

  if (
    element &&
    store instanceof Map &&
    store.size > 0
  ) {
    const input = element.querySelector(".quantity__input");
    if (!input) return;

    const [[id, variant]] = store.entries();
    const qty = variant?.appliedQI?.qty_increment;

    if (!qty) return;

    input.value = qty;
    input.setAttribute("min", qty);
    input.setAttribute("step", qty);
    input.setAttribute("data-min", qty);
    input.setAttribute("data-cart-quantity", qty);

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    if (block) {
      block.style.pointerEvents = "";
      block.style.opacity = "";
    }

    clearInterval(interval);
  } else {
    counter += 100;
    if (counter >= 10000) clearInterval(interval);
  }
}, 100);
